import {Layout} from "antd";

import React, {useContext,useEffect} from "react";
import { useParams} from "react-router-dom";
import {connect, useDispatch} from "react-redux";
import {AuthContext} from "../../../components/Auth/AuthProvider";
import {callJobApi} from "../../util/redux/asyncActions";

const {Content} = Layout

const select = state =>{
    const jobStatus = state.request.jobStatus
    const loading  = state.request.loading
    const error = state.request.error
    return{
        jobStatus,
        loading,
        error
    }
}

function Jobs (props)  {

    const {loading,jobStatus,error} = props;

    const { id,cmd } = useParams();
    const dispatch = useDispatch();
    const userManager = useContext(AuthContext);



    const [ready,setReady] = React.useState(false);
    const [msg,setMsg] = React.useState("");

    useEffect(()=>{
        if (!ready){

            dispatch(callJobApi({id,cmd,userManager}))
        }else{
            setReady(true)
        }
    },[ready])

    useEffect(() => {
        if (!loading && jobStatus && error.length==0){
            setMsg(`The job ${id} has been started`)
            const timer = setTimeout(() => {
                window.open('', '_self'); // aktuelle Seite ersetzen
                window.close();

            }, 3000);

        }
        if (!loading && error.length>0){

            setMsg(`The job ${id} has not been started. Error: ${error}`)
        }
    }, [loading]);

    return (


       <Layout>
           <Content>
                <div>
                    {msg}
                 </div>
            </Content>
       </Layout>


    );
}

export default connect(select)(Jobs)

